import React from 'react';
import Tooltip from './Tooltip';
import clsx from 'clsx';

const Statistics = ({ children }) => {
  return <div className={`grid gap-x-6 flex-1 mr-6 grid-cols-20`}>{children}</div>;
};

const StatisticsItem = ({ className, colSpan, children }) => {
  return (
    <div className={clsx(`truncate`, className)} style={{ gridColumn: `span ${colSpan}` }}>
      {children}
    </div>
  );
};

const StatisticsText = ({ className, children, tooltip }) => {
  return (
    <div className={clsx(`text-gray-700 text-sm font-normal`, className)}>
      {tooltip ? (
        <Tooltip label={tooltip} placement="top" triggerClassName="relative z-10">
          {children}
        </Tooltip>
      ) : (
        children
      )}
    </div>
  );
};

const StatisticsMetric = ({ children }) => {
  return <h6 className="font-medium truncate">{children}</h6>;
};

Statistics.Item = StatisticsItem;
Statistics.Text = StatisticsText;
Statistics.Metric = StatisticsMetric;

export default Statistics;
